/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PreOpAddlAssessment from './pre-op-addl-assessment';
import PreOpAddlAssessmentDetail from './pre-op-addl-assessment-detail';
import PreOpAddlAssessmentUpdate from './pre-op-addl-assessment-update';
import PreOpAddlAssessmentDeleteDialog from './pre-op-addl-assessment-delete-dialog';

const PreOpAddlAssessmentRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PreOpAddlAssessment />} />
    <Route path="new" element={<PreOpAddlAssessmentUpdate />} />
    <Route path=":id">
      <Route index element={<PreOpAddlAssessmentDetail />} />
      <Route path="edit" element={<PreOpAddlAssessmentUpdate />} />
      <Route path="delete" element={<PreOpAddlAssessmentDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PreOpAddlAssessmentRoutes;
